<template lang="pug">
app-page(:fab-items="items" title="Мои дела")
  v-container(fluid p-0)
    v-layout
      CaseToolbar(:isLimitView="isLimitView")
            
    v-layout(align-start)
      v-flex(xs7 sud-block-overlay v-if="!isLimitView")
        .sud-block-title Документы по делу
          span.ml-4(v-if="selectedMember") ({{ selectedMember.displayName }})
        .text-xs-center.m-5(v-if="documents.length == 0") В сессии отсутствуют документы по делу {{ currentPredicate ? '(' + currentPredicate + ')' : ''}}
        CaseDocuments

      v-flex(:class="leftViewSize" sud-block-overlay)
        .sud-block-title Информация по делу
        CaseSession(:isLimitView="isLimitView")

        .ma-0( v-if="$_meeting_isAvailable" )
          .sud-block-title Стенограмма и видеочат
          CaseTranscript

        .sud-block-title(v-if="members.length != 0") Стороны по делу
        CaseMembers


    CaseAddDocument(v-model="dialog.document")
    CaseAddDataRequest(v-model="dialog.datarequest" :members="members")
    CaseEditMember(v-model="dialog.member")
    CaseAddSession(v-model="dialog.addSession")
    CaseEdit(v-model="dialog.editCase")
    
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AppToolbarItemDivider } from '@/components'

import CaseDocuments from "./components/CaseDocuments"
import CaseMembers from "./components/CaseMembers"
import CaseSession from "./components/CaseSession"
import CaseTranscript from "./components/CaseTranscript"

import CaseToolbar from "./components/CaseToolbar"

import CaseEditMember from './components/CaseEditMember'
import CaseAddDocument from './components/CaseAddDocument'
import CaseAddDataRequest from './components/CaseAddDataRequest'
import CaseAddSession from './components/CaseAddSession'
import CaseEdit from './components/CaseEdit'

import { caseService } from "@/_services"

import { $_user_role as Role } from '@/common/UserUtils'
import Meeting from '@/common/Meeting'

export default {
  mixins: [Meeting],

  components: {
    CaseDocuments,
    CaseMembers,
    CaseSession,
    CaseTranscript,
    CaseToolbar,
    CaseAddDocument,
    CaseEditMember,
    CaseAddDataRequest,
    CaseAddSession,
    CaseEdit
  },

  props: {
    caseId: null
  },

  mounted() {
    this.$store.dispatch('courtCase/INIT', { caseId: this.caseId })
  },

  methods: {

    goToMemberForm () {
      this.$router.push({ path: `/case/${this.caseId}/member/new` })
    },

    showAddDocumentForm () {
      this.dialog.document = true
    },

    showDataRequestDialog () {
      this.dialog.datarequest = true
    },

    showAddSession () {
      this.dialog.addSession = true
    },

    showEditCase () {
      this.dialog.editCase = true
    },

    genCode() {
      caseService.genCodes(this.caseId).then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
      })
    },

  },

  computed: {
    ...mapState('courtCase', ['selectedMember', 'currentPredicate', 'courtCase']),
    ...mapGetters('courtCase', ['documents', 'members', 'caseNumber', 'isActiveSession']),
    ...mapGetters('me', ['hasRole']),

    items () {
      document.title = "Дело №" + this.caseNumber

      let items = !this.isActiveSession ? [] : this.isLimitView  ? [] : [
        { icon:'contact_support', title:'Запрос', action: () => this.showDataRequestDialog() }, 
        { icon:'note', title:'Документ на основе шаблона', action: () => this.showAddDocumentForm() },
        AppToolbarItemDivider,
      ]

      if (this.$_meeting_isAvailable && this.isActiveSession) items.push({ icon:'code', title:'Сгенерировать одноразовые пароли', action: () => this.genCode() })

      if (this.isActiveSession) items.push({ icon:'person', title:'Участника по делу', action: () => this.goToMemberForm() })
      
      if (this.$_meeting_isAvailable) {
        items.push({ icon:'add', title:'Сессию', action: () => this.showAddSession() })
        items.push(AppToolbarItemDivider, { icon:'edit', title:'Редактировать дело', action: () => this.showEditCase() })
      }
      
      return items
    },

    isLimitView() {
      return this.hasRole([Role.limitjudge])
    },
    leftViewSize() {
      return this.hasRole([Role.limitjudge])? "xs12" :"xs5"
    },

  },

  data () {
    return {
      dialog: {
        document: false,
        member: false,
        datarequest: false,
        addSession: false,
        editCase: false
      },
    }
  }
}
</script>
